import React from 'react';
import { SettingsOption } from 'src/model/api/v2/data-contracts';
import { SettingsSection } from 'src/pages/ProjectSettingsPage/components/SettingsSection';
import { SettingsSelect } from 'src/pages/ProjectSettingsPage/components/SettingsSelect';
import { IconSetIcon } from 'src/icons/IconSetIcon';
import { ts } from 'src/utils/translate';

type Props = {
    value: number;
    options: SettingsOption[];
    onChange: (iconSetId: number) => void;
};

export const IconSetSection = ({ value, options, onChange }: Props) => {
    const title = ts('profile_settings_preferred_icon_set', 'Preferred icon set');

    return (
        <SettingsSection title={title} titleIcon={<IconSetIcon />}>
            <SettingsSelect
                id="profile-icon-set"
                label={title}
                hideLabel
                value={value}
                options={options}
                onChange={onChange}
            />
        </SettingsSection>
    );
};
